import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { BookOpen, Utensils, Calendar, ShoppingBag } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-8 h-8 text-brand-orange" data-id="element-209" />,
    title: 'Ebook Central Reset Metabólico 45+',
    description: 'El manual paso a paso con la ciencia aplicada a tu vida diaria.'
  }, {
    icon: <Utensils className="w-8 h-8 text-brand-orange" data-id="element-210" />,
    title: 'Protocolo de Nutrición Sincronizada',
    description: 'Qué comer y en qué orden exacto para aplanar la curva de glucosa.'
  }, {
    icon: <Calendar className="w-8 h-8 text-brand-orange" data-id="element-211" />,
    title: 'Plan de Acción de 21 Días',
    description: 'Una hoja de ruta clara para que no tengas que pensar qué hacer cada mañana.'
  }, {
    icon: <ShoppingBag className="w-8 h-8 text-brand-orange" data-id="element-212" />,
    title: 'Checklist de Compras',
    description: 'Aprendé a detectar los "falsos saludables" en la góndola del chino o el súper.'
  }];
  return <section className="py-24 bg-brand-cream" data-id="element-213">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-214">
        <FadeIn data-id="element-215">
          <div className="text-center mb-16" data-id="element-216">
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-217">
              Todo lo que recibís hoy
            </h2>
            <div className="w-24 h-1 bg-brand-orange mx-auto rounded-full" data-id="element-218"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-219">
          {deliverables.map((item, index) => <FadeIn key={index} delay={0.1 * index} direction="up" data-id="element-220">
              <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-shadow duration-300 border border-brand-orange/10 h-full flex flex-col" data-id="element-221">
                <div className="w-16 h-16 rounded-full bg-brand-orange/10 flex items-center justify-center mb-6" data-id="element-222">
                  {item.icon}
                </div>
                <h3 className="font-serif text-xl font-bold text-brand-charcoal mb-3" data-id="element-223">
                  {item.title}
                </h3>
                <p className="text-gray-600 leading-relaxed flex-grow" data-id="element-224">
                  {item.description}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} className="text-center" data-id="element-225">
          <CTAButton data-id="element-226" />
        </FadeIn>
      </div>
    </section>;
}